<template>
  <div class="icon-content">
    <!-- 提示信息 -->
    <div class="notice-container">
      <van-notice-bar
        style="line-height: 20px"
        color="#FD8D32"
        background="#FFEEE0"
        wrapable
      >
        <span style="font-size: 12px"
          >注意：如当前设备使用的是移动网络，设备每隔30天需做一次认证，未及时认证连接设备将无法使用网络！</span
        >
      </van-notice-bar>
    </div>
    <!-- 顶部图标 -->
    <img class="icon-tip" :src="appData.agentLogoUrl" />

    <!-- 宣传语 -->
    <div class="center-tip">无线上网认证</div>

    <!-- 认证表单 -->
    <div class="center-content">
      <div class="row-box">
        <div class="left-box">
          <div class="label">登记手机号</div>
          <input
            class="input-style"
            type="tel"
            placeholder="请输入登记手机号"
            v-model="phone"
          />
        </div>
      </div>

      <div class="row-box">
        <div class="left-box">
          <div class="label">验证码</div>
          <input
            class="input-style"
            type="tel"
            placeholder="请输入验证码"
            v-model="smsCode"
            maxlength="6"
          />
        </div>

        <div class="right-box">
          <button
            class="get-code-button"
            @click="getCodeAction"
            :disabled="isCodeButtonDisabled"
          >
            {{ isCodeButtonDisabled ? `${countdown}秒后重试` : "获取验证码" }}
          </button>
        </div>
      </div>

      <div class="tip-conent">
        <img class="tip-icon" src="@/assets/Attention2025.png" />
        <p>一个手机号一天只能接收5次验证码</p>
      </div>
    </div>

    <!-- 提交按钮 -->
    <div class="buy-button" @click="commitAction">提交</div>

    <!-- 设备信息 -->
    <div class="device-conent">
      <!-- <div class="device-top">
        <p>认证设备</p>
      </div> -->
      <div class="btn-update" @click="updateAction">更新</div>
      <div class="device-center">
        <p class="center-left">认证状态：</p>
        <p>
          {{
            authState === "Y" ? "已认证" : authState === "N" ? "未认证" : "--"
          }}
        </p>
      </div>

      <div class="device-foot">
        <div class="foot-left">认证有效期：</div>
        <div>{{ authExpireTime || "--" }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getWirelessTerminalSmsCode,
  getWirelessTerminalAuth,
  getWirelessTerminalInfo,
  getWirelessTerminalAuthStatus,
  updateWirelessTerminalAuthStatus,
} from "@/api/home";
import { Toast } from "vant";

export default {
  data() {
    return {
      phone: "",
      smsCode: "",
      isCodeButtonDisabled: false,
      countdown: 60,
      deviceRemark: "--",
      sn: "",
      mac: "",
      terminalMac: "",
      id: "",
      authState: "",
      authExpireTime: "",
    };
  },

  watch: {
    phone(newVal) {
      this.phone = newVal.replace(/\D/g, "").slice(0, 11); // 移除非数字字符，并限制长度
    },
    smsCode(newVal) {
      // 移除非数字字符，限制6位
      this.smsCode = newVal.replace(/\D/g, "").slice(0, 6);
    },
  },

  mounted() {
    // this.id = this.$route.query.id;
    this.sn = this.$route.query.sn;
    this.getWirelessTerminalAuthStatusEvent();
    // this.deviceRemark = this.$route.query.deviceRemark;
    // if (this.deviceRemark === "undefined") {
    //   this.deviceRemark = "--";
    // }
    // this.mac = this.$route.query.mac;
    // this.terminalMac = this.$route.query.terminalMac;

    //如果为空，掉信息接口获取终端信息
    // if (!this.terminalMac) {

    // }
  },

  methods: {
    // 获取认证状态
    getWirelessTerminalAuthStatusEvent() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getWirelessTerminalAuthStatus({
        sn: this.sn,
      }).then((res) => {
        this.$toast.clear();
        this.authState = res.authState;
        this.authExpireTime = res.authExpireTime;
        // this.terminalMac = res.terminalMac;
        // this.deviceRemark = res.remark;
      });
    },
    // 更新认证状态
    updateAction() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      updateWirelessTerminalAuthStatus({
        sn: this.sn,
      }).then((res) => {
        Toast.success("更新成功");
        setTimeout(() => {
          this.getWirelessTerminalAuthStatusEvent();
        }, 1000);
      });
    },
    // 提交认证
    commitAction() {
      if (!this.validateForm()) {
        return;
      }

      Toast.loading({
        message: "认证中...",
        forbidClick: true,
      });

      getWirelessTerminalAuth({
        mobile: this.phone,
        verifyCode: this.smsCode,
        sn: this.sn,
      }).then((res) => {
        Toast.success("认证成功");
        var backSN = res;
        // 延迟跳转，确保 Toast 显示完成
        setTimeout(() => {
          this.uni.navigateTo("/home/InternetAuthList?sn=" + backSN);
        }, 800);
      });
    },

    // 表单验证
    validateForm() {
      if (!this.phone) {
        Toast.fail("请输入手机号");
        return false;
      }

      if (this.phone.length !== 11) {
        Toast.fail("手机号格式有误，请重新输入");
        return false;
      }

      if (!this.smsCode) {
        Toast.fail("请输入验证码");
        return false;
      }

      return true;
    },

    // 获取验证码
    getCodeAction() {
      if (!this.phone) {
        Toast.fail("请输入手机号");
        return;
      }

      if (this.phone.length !== 11) {
        Toast.fail("手机号格式有误，请重新输入");
        return;
      }

      if (this.isCodeButtonDisabled) {
        return;
      }

      this.isCodeButtonDisabled = true;

      getWirelessTerminalSmsCode({
        mobile: this.phone,
        sn: this.sn,
      }).then((res) => {
        Toast.success("验证码发送成功");
        this.startCountdown(60);
      });
    },

    startCountdown(seconds) {
      this.countdown = seconds;
      const interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(interval);
          this.isCodeButtonDisabled = false;
          this.countdown = 60;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.icon-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  width: 100%;
  min-height: 100vh;
  .notice-container {
    // width: 100%;
    // height: 100px;
  }
  .icon-tip {
    margin-top: 126px;
    width: 136px;
    height: 136px;
  }

  .center-tip {
    color: #333;
    font-size: 36px;
    font-weight: bold;
    margin-top: 30px;
    text-align: center;
  }

  .center-content {
    margin: 50px 0 80px;
    background-color: #fff;
    border-radius: 16px;
    width: calc(100vw - 64px);
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .row-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    padding: 12px 20px;
    box-shadow: 0 4px 8px rgba(102, 102, 102, 0.15);
    height: 85px;
    margin-bottom: 40px;

    .left-box {
      flex: 1;
      display: flex;
      align-items: center;
      min-width: 0;

      .label {
        width: 180px;
        flex-shrink: 0;
        font-size: 32px;
        color: #1d2129;
      }

      .input-style {
        flex: 1;
        min-width: 0;
        height: 60px;
        padding: 0 10px;
        font-size: 32px;
        border: none;
        outline: none;

        &::placeholder {
          color: #9d9d9d;
        }
      }
    }

    .get-code-button {
      padding: 12px 16px;
      background-color: var(--primary-color);
      border: none;
      border-radius: 8px;
      color: #fff;
      font-size: 24px;
      white-space: nowrap;
    }
  }

  .tip-conent {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #999999;
    height: 30px;

    .tip-icon {
      width: 32px;
      height: 32px;
      padding-right: 16px;
    }
  }

  .buy-button {
    background-color: var(--primary-color);
    color: #fff;
    font-size: 32px;
    width: calc(100vw - 64px);
    height: 90px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    cursor: pointer;
    transition: opacity 0.2s ease;
    margin-bottom: 50px;
  }

  .device-conent {
    display: flex;
    flex-direction: column;
    background-color: #f2f5fa;
    border-radius: 16px;
    width: calc(100vw - 64px);
    position: relative;
    // padding-left: 15px;
    .btn-update {
      position: absolute;
      top: 50%;
      right: 24px;
      transform: translateY(-50%);
      width: 152px;
      height: 48px;
      background: var(--primary-color);
      border-radius: 8px;
      font-size: 24px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .device-top {
      color: #333333;
      font-size: 34px;
      font-weight: bold;
      margin-left: 25px;
    }

    .device-center,
    .device-foot {
      display: flex;
      align-items: center;
      font-size: 30px;
      color: #333333;
      margin-bottom: 12px;
      gap: 20px;
      margin-left: 25px;

      .center-left,
      .foot-left {
        color: #868686;
        min-width: 100px;
      }
    }

    .device-foot {
      margin-bottom: 30px;
    }
  }
}
</style>
